var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-item" }, [
    _c("div", { staticClass: "menu-item-wrapper" }, [
      _c("div", { staticClass: "menu-item-content" }, [
        _vm.imageExist
          ? _c("div", { staticClass: "menu-item-image" }, [
              _c(
                "picture",
                {
                  directives: [
                    {
                      name: "lazyload",
                      rawName: "v-lazyload",
                      value: {
                        src: _vm.menuItem.imageSrc,
                        variant: "menu-list",
                      },
                      expression:
                        "{ src: menuItem.imageSrc,\n                  variant: 'menu-list' }",
                    },
                  ],
                  key: "" + _vm.menuItem.title,
                  staticClass: "image-wrapper",
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                      alt: _vm.menuItem.imageAlt,
                    },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "menu-item-info" }, [
          _c("div", { staticClass: "menu-item-title" }, [
            _vm._v("\n          " + _vm._s(_vm.menuItem.title) + "\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-item-desc" }, [
            _c("div", {
              staticClass: "desc-wrapper",
              domProps: { innerHTML: _vm._s(_vm.formattedDescription.text) },
            }),
            _vm._v(" "),
            _vm.formattedDescription.isTruncated
              ? _c(
                  "a",
                  {
                    class: [
                      "toggle-button",
                      "button",
                      _vm.showFullDescription ? "less" : "more",
                    ],
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleDescriptionVisibility($event)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.showFullDescription
                            ? _vm.tc("pageContent.seeLessButtonLabel")
                            : _vm.tc("pageContent.seeMoreButtonLabel")
                        ) +
                        "\n          "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "schedule-list" },
        _vm._l(_vm.menuItem.gridCardRows, function (item) {
          return _c(
            "div",
            { key: "key-" + item.id, staticClass: "schedule-item" },
            [
              _c("div", { staticClass: "schedule-item-grid" }, [
                item.duration
                  ? _c("div", { staticClass: "duration" }, [
                      _vm._v(_vm._s(item.duration)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.dayAndTime
                  ? _c(
                      "div",
                      { staticClass: "time" },
                      _vm._l(item.dayAndTime, function (item, index) {
                        return _c("div", { key: "card-time-" + index }, [
                          _vm._v(_vm._s(item)),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.price
                  ? _c("div", {
                      staticClass: "price",
                      domProps: { innerHTML: _vm._s(item.price) },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              item.priceLabel
                ? _c("div", { staticClass: "price-label" }, [
                    _vm._v(_vm._s(item.priceLabel)),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.menuItem.secondaryCTA || _vm.menuItem.primaryCTA
      ? _c("div", { staticClass: "menu-item-ctas" }, [
          _vm.menuItem.secondaryCTA
            ? _c(
                "a",
                {
                  staticClass: "button secondary",
                  attrs: {
                    target: _vm.menuItem.secondaryCTATarget,
                    href: _vm.menuItem.secondaryCTA,
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.menuItem.secondaryCTALabel
                        ? _vm.menuItem.secondaryCTALabel
                        : _vm.tc("pageContent.inquireButtonLabel")
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.menuItem.primaryCTA
            ? _c(
                "a",
                {
                  staticClass: "button--primary black size-md primary",
                  attrs: {
                    target: _vm.menuItem.primaryCTATarget,
                    href: _vm.menuItem.primaryCTA,
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.menuItem.primaryCTALabel
                        ? _vm.menuItem.primaryCTALabel
                        : _vm.tc("pageContent.bookButtonLabel")
                    )
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }